import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link, withRouter} from "react-router-dom";
import { Capacitor, Plugins } from "@capacitor/core";

import AuthLayout from "../../shared/containers/AuthLayout";
import {Group} from "../../shared/components/Group";
import {checkUserMode, getSeniors} from "./actions/seniorsAction";
import {getRelatives, maskEmailProvider} from "./actions/relativesAction";
import {logout} from "../user/actions/userAction";
import relativesImage from '../../../assets/img/relatives_211x211.png';
import version from "../../../../version.json";
import {
  ROUTER_MEMBERS_DELETE_RELATION,
  ROUTER_MEMBERS_INVITE
} from "../../shared/constants/routers";
import {MODE_B2B_COMMUNICATION} from "../user/constants";


class Members extends React.Component {

  static propTypes = {
    seniors: PropTypes.array,
    relatives: PropTypes.array,
    onLogout: PropTypes.func,
    user: PropTypes.object
  };

  static defaultProps = {
    seniors: [],
    relatives: [],
    user: {}
  };

  state = { version: version.tag };

  constructor(props, context) {
    super(props, context);

    if (Capacitor.isNative) {
      Plugins.Device.getInfo()
        .then((device) => {
          this.setState({ version: device.appVersion });
        });
    }
  }

  renderRelatives = (relative, relativeIndex) => {
    return (
      <div key={relativeIndex}
           className={"flexBox direction-row center-center " +
           (relative.email === this.props.user.email
             ? "highlight"
             : "")}>
        <div
          className="userProfilePic"
          style={{backgroundImage: `url(${relativesImage})`}}
        />
        <div className="flex memberInfo">
          <div className="flex memberName">
            {relative.firstname} {relative.lastname}
          </div>
          <div className="flex memberEmail">
            {maskEmailProvider(relative.email)}
          </div>
        </div>
      </div>
    )
  };
  renderSerniorList = (senior, seniorIndex) => {
      return (
        <div key={seniorIndex} className="connectionsGroup">
          <Group title={__("Senior who uses the tablet:")}>
            <div className="flexBox direction-row center-center">
              <div
                className="userProfilePic"
                style={{backgroundImage: `url(${senior.imgUrl})`}}
              />
              <div className="flex memberName">
                {senior.firstname} {senior.lastname}
              </div>
            </div>
          </Group>
          <Group title={__("People using the portal:")}
                 listType="sortedList"
          >
            {senior.relatives.map(this.renderRelatives)}
          </Group>
          <Group listType="buttonList">
            <Link className="buttonStyleLess" to={{
              pathname: ROUTER_MEMBERS_INVITE,
              state: {senior: senior}
            }}>
              <i className="fa fa-plus"/>{__("Invite to the family portal!")}
            </Link>
          </Group>
          {this.props.seniors.length > 1 && <Group listType="buttonList">
            <Link className="buttonStyleLess" to={{
              pathname: ROUTER_MEMBERS_DELETE_RELATION,
              state: {senior: senior}
            }}>
              <i className="fa fa-minus-circle"/>{__("Delete connection to this senior")}
            </Link>
          </Group>}
        </div>
      );
  };

  componentDidMount() {
    this.props.dispatch(getSeniors())
      .then((seniors) => {
        this.props.dispatch(checkUserMode(seniors));
        this.props.dispatch(getRelatives(seniors))
      });
  }

  render() {
    const uiListSenior = this.props.seniors.map(this.renderSerniorList);
    const isCommunicationOnly = this.props.user.mode === MODE_B2B_COMMUNICATION;

    return (
      <AuthLayout title={__("Members")}
                  description={__("Invite more people to the family portal.")}>
        <div className="connectionsWrapper">
          {!isCommunicationOnly && uiListSenior}
        </div>
        <div className="referenceLinks">
          <div className="title">{__("Legal Notice")}</div>
          <a href="https://www.media4care.de/datenschutz/" target="_blank"
             rel="noopener noreferrer">
            {__("Data protection")}
          </a>
          <a href="https://www.media4care.de/impressum/" target="_blank"
             rel="noopener noreferrer">
            {__("Imprint")}
          </a>
        </div>
        <button
          className="buttonStyleLogout logout"
          onClick={this.props.onLogout}
        >
          {__("Sign out")}<i className="fa fa-sign-out right"/>
        </button>
        <div>
          <span
            className="description">version: {this.state.version} </span>
        </div>
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    seniors: state.seniors,
    relatives: state.relatives,
    user: state.user
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { onLogout: logout },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Members));
